import React, { useState, useEffect } from "react";
import CurrencyInput from "react-currency-input-field";

export default function DataEntryField({ id, defaultValue , className, onChange, onInputChange }) {
  const [inputValue, setInputValue] = useState(defaultValue);

  const handleChange = (newValue) => {
    if (newValue === undefined) {
      setInputValue("0");
      onInputChange("0");
    } else {
      setInputValue(newValue);
      onInputChange(newValue);
    }
  };

  const handleKeyUp = () => {
    onChange(inputValue);
  }

  useEffect(() => {
    setInputValue(defaultValue);
  }, [defaultValue]);

  return (
    <>
      <CurrencyInput
        className={className}
        allowDecimals
        decimalSeparator="."
        id={id}
        name="input-currency-field-name"
        prefix="$"
        value={inputValue}
        onValueChange={handleChange}
        onBlur={handleKeyUp}
        step={1}
        placeholder="$0.0"
        autoFocus="true"
      />
    </>
  );
}